<template>
    <Loader :isLoading="isLoading"/>
      <div class="container-fluid" v-show="!isLoading">
        <form class="row g-3" @submit.prevent="preUpdateOpenTrip">
             <div class="mt-4 col-12 card card-body">
                <div class="row">
                    <div class="col-12">
                        <h6 class="mb-0">Información de la apertura</h6>
                        <hr class="mt-3 horizontal dark" />    
                    </div> 
                    <div class="col-12 col-lg-6 offset-lg-3 mt-3">
                        <label>No. semanas de disponibilidad(<span class="text-danger">*</span>)</label>
                        <input type="number" v-model="trip.numberWeeks" @input="generateDates()" class="form-control" placeholder="eg. 2" id="numberWeeks" :class="{ 'is-invalid': errors.numberWeeks, 'is-valid': errors.numberWeeks === null }">
                        <div v-if="errors.numberWeeks" style="color: red">
                                {{ errors.numberWeeks }}
                        </div>
                    </div>
                    <div class="col-12 mt-4" v-show="showDetails">
                        <div class="row">
                          <div class="col-12 col-lg-12 text-center ">
                            <span class="badge badge-info size-date">{{dates.startDate}}</span>
                            <span class="mx-2 size-date">-</span>
                            <span class="badge badge-success size-date">{{dates.endDate}}</span>
                          </div>

                           <div class="col-12 col-lg-8 offset-lg-2 mt-2 text-center" >
                              Rango de fechas contempladas para la repetición de los viajes abiertos
                          </div>
                        </div>
                    </div>

                    <div class="col-12 text-end mt-4">
                         <button type="button" class="btn bg-gradient-secondary mb-0 me-2 ms-auto js-btn-next" title="Cancelar" @click="cancelar">Cancelar</button>
                         <button type="submit" class="btn bg-gradient-dark mb-0 ms-auto js-btn-next" title="Guardar Apertura" >Guardar</button>
                    </div>   
                </div>  
             </div>
        </form>
      </div>
</template>

<script>
//import router from '../../../../router/index'
import Loader from '../../../../components/Loader.vue'
import listTripsUnopened from '../../../../modules/travels/use-cases/list.trips.unopened'
import updateOpenTrip from '../../../../modules/openTrip/use-cases/update.open.trip'
import moment from 'moment'
import openTripValidator from '../../../../kernel/validators/opentrip.validator'
import router from '../../../../router/index'
import getTripOpened from '../../../travels/use-cases/get.trip.opened'

export default {
  name: "UpdateOpenTrips",
  components:{
    Loader
  },
  data(){
    return{
        isLoading: false,
        dates:{
          startDate:"",
          endDate: ""
        },
        openTrip:{
            trip: "",
            numberWeeks: "",
        },
        errors:{
            trip: "",
            numberWeeks: "",
        },
        trips: [],
        trip:{},
        showDetails: false,
        tripOriginal:{},
        idTrip: 0,
    }
  },
  async mounted(){
    this.idTrip = this.$route.params.id;
    await this.getTrip(this.idTrip)
    await this.listTripsUnopened()
  },
  methods:{
    generateDates(){
      if(this.trip.numberWeeks && this.trip.numberWeeks !== undefined && this.trip.numberWeeks !== ''){
          this.showDetails = true;
          this.generateAproachDates(this.trip.repeatStartDate, this.trip.numberWeeks);
      }else{
          this.showDetails = false;
      }
    },
    generateAproachDates(startDate, numberWeeks){
      this.dates.startDate = moment(startDate).format('DD-MM-YYYY HH:mm');
      let preDate = moment(startDate).add(numberWeeks, 'weeks');
      this.dates.endDate = preDate.format('DD-MM-YYYY HH:mm');
    },
     async getTrip(id){
      this.isLoading = true;
      const response = {...await getTripOpened(id)};
      const {error, data} = response;
      this.isLoading = false;
      if(!error){
          const {result} = data
          this.trip = {...result};
          this.tripOriginal = {...result};
          this.showDetails = this.trip.numberWeeks && this.trip.numberWeeks !== undefined && this.trip.numberWeeks !== '';
          this.generateAproachDates(this.trip.repeatStartDate, this.trip.numberWeeks)
      }else{
           this.$swal({
            icon: "error", 
            title: 'Ocurrió un error durante la consultar. Inténtalo de nuevo.',
            type: "basic",
          });
      }
    },
    async listTripsUnopened(){
      const response = {...await listTripsUnopened()};
      const {error, data} = response;
      if(!error){
          const {result} = data
          this.trips = result;
      }else{
          this.$swal({
            icon: "error", 
            title: 'Ocurrió un error durante la consultar. Inténtalo de nuevo.',
            type: "basic",
          });
      }
    },
    async preUpdateOpenTrip(){
      this.errors.numberWeeks = openTripValidator.validateNumberWeeks(this.trip.numberWeeks);

      if(!this.errors.numberWeeks){
          this.$swal({
          title: "¿Estás seguro(a) de guardar los cambios?",
          text: "¡No podrás revertir esto.!",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonText: "Confirmar",
          customClass: {
            confirmButton: "btn bg-gradient-success",
            cancelButton: "btn bg-gradient-secondary",
          },
          buttonsStyling: false,
        }).then(async(result) => {
          if (result.isConfirmed) {
            let payload = {
              idTrip: this.trip.id,
              numberWeeks: this.trip.numberWeeks
            }
              this.isLoading = true;
             const {message, error, data} = await updateOpenTrip(payload)
              this.isLoading = false;
              if(!error){
                const {text} = data
                this.$swal({
                  icon: "success",
                  title: message,
                  text: text,
                  type: 'success-message',
                });
                router.push({name: 'Consultar Aperturas'})
              }else{
                const {text} = data
                this.$swal({
                    icon: "error", 
                    title: message,
                    text: text,
                    type: "basic",
                  });
              }
          } else if (result.dismiss === this.$swal.DismissReason.cancel) {
            this.$swal.dismiss;
          }
        });
      }
    },
    cancelar(){
       router.push({name: 'Consultar Aperturas'})
    }
  }
}
</script>

<style scoped>
  .size-date{
    font-size: 1em;
  }
</style>